import { store } from "../store";
import { store as uiStore } from "../store/ui";
import { lang } from "../lang";

export function clearSession(): void {
    if (store.sessionExpired) {
        store.doNotice(lang.sessionExpired);
    }

    localStorage.clear();
    uiStore.clearSession();
    store.clearSession();
}
